import * as React from 'react';

function SvgPencil(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M13.684 5.888L2.782 16.928 2 22l5.167-.543L18.11 10.373l-4.427-4.485zM16.89 2.47l-2.111 2.111 4.64 4.641 2.112-2.11a.665.665 0 000-.941l-3.7-3.7a.665.665 0 00-.942 0z" })));
}

export default SvgPencil;
